import { render, staticRenderFns } from "./channel-edit.vue?vue&type=template&id=328ba9d2&scoped=true"
import script from "./channel-edit.vue?vue&type=script&lang=js"
export * from "./channel-edit.vue?vue&type=script&lang=js"
import style0 from "./channel-edit.vue?vue&type=style&index=0&id=328ba9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ba9d2",
  null
  
)

export default component.exports